<template>
    <button type="button" @click="handleGoogleAuth"
        class="w-full border border-slate-200 flex items-center justify-center px-4 py-2 gap-4 rounded-lg text-slate-700 hover:border-slate-400 hover:text-slate-900 hover:shadow transition duration-150">
        <img class="w-6 h-6" src="@/assets/icons/google.svg" loading="lazy" alt="google logo">
        <span>Continue with Google</span>
    </button>
    <div
        class="py-3 flex items-center text-xs text-gray-400 uppercase before:mr-2 before:flex-1 before:border-t before:border-gray-200 before:me-6 after:ml-2 after:flex-1 after:border-t after:border-gray-200 after:ms-6 dark:text-neutral-500 dark:before:border-neutral-600 dark:after:border-neutral-600">
        Or</div>
</template>


<script lang="ts">
import { Icon } from '@iconify/vue';
import { Options, Vue } from 'vue-class-component';
import { gapi } from 'gapi-script';
import { login } from '../../actions/auth';
import { usePayloadStore } from '../../stores/payload';
@Options({
    components: {
        Icon
    }
})
export default class GoogleAuth extends Vue {
    public mounted() {
        gapi.load('client:auth2', this.initClient);
    }

    public initClient() {
        gapi.client.init({
            clientId: process.env.GOOGLE_CLIENT_ID,
            scope: 'profile email',
        });
    }
    private payloadStore = usePayloadStore();

    public handleGoogleAuth = async () => {
        const auth2 = gapi.auth2.getAuthInstance();
        try {
            const googleUser = await auth2.signIn();
            const token = googleUser.getAuthResponse().id_token;
            this.$emit('token', token);
        } catch (error) {
            console.error('Google sign-in failed', error);
            this.$emit('token', '');
        }
    };
}
</script>